<template>
  <div class="container-fluid city-banner">
    <img class="image" :src="this.getContentfulImgURL({ url: imageurl })" />
      <div class="banner-overlay"></div>
      <div class="container">
        <h1>{{ label }}</h1>
        <read-more
          v-if="subTitle"
          class="city-keyword"
          more-str="read more"
          :text="subTitle"
          less-str="read less"
          :max-chars="maxChar"
        />
      </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// read more
import Vue from 'vue'
import ReadMore from 'vue-read-more'
Vue.use(ReadMore)

import imageOptimo from '~/mixins/imageOptimoMixin.js'
export default {
  mixins: [imageOptimo],
  name: 'CityBanner',
  props: {
    imageurl: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: false
    },
    subTitle: {
      type: String,
      required: false
    }
  },
  computed: {
    ...mapGetters([
      'screenWidth'
    ]),
    maxChar () {
      if (this.screenWidth > 1024) {
        return 1500
      } else if (this.screenWidth >= 768) {
        return 500
      }
      return 100
    }
  }
}
</script>

<style lang="scss">
.city-banner .city-keyword {
  max-width: 800px;
  > p {
    display: inline;
    font-family: $heading-family;
    font-size: 18px;
    line-height: 26px;
    font-weight: 700 !important;
    color: $white;
  }
  #readmore {
    display: inline;
    font-family: $heading-family;
    font-weight: 700;
    font-size: 18px !important;
    line-height: 26px;
    text-decoration: underline !important;
    text-transform: lowercase;
    color: $white;
  }
}
</style>
<style lang="scss"  scoped>
.city-banner {
  height: 331px;
  padding: 0 0;
  margin: 0 0;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  display: flex;
  align-items: center;
  position: relative;
  .container {
    width: 100%;
    display: block;
    z-index: 0;
    h1 {
      @include header-2;
      color: #FFF;
    }
    h2{
      @include subtitle-2-bold;
      color: #FFF;
      max-width: 700px;
    }
  }
  .image {
    position: absolute;
    z-index: -1;
    height: 100%;
    width: 100%;
    object-position: center;
    object-fit: cover;
  }
  .banner-overlay {
    position: absolute;
    background: linear-gradient(88.16deg, #5E2013 2.07%, rgba(68, 60, 71, 0) 87.72%);
    height: inherit;
    width: inherit;
    top: 0px;
  }

  @include max-width($mobile-extra) {
    .container h1{
      @include header-3;
    }
  }
}
</style>
